import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.paddings(20, 10),
  width: 320,
  backgroundColor: "transparent",
  position: "relative",
  borderLeft: "3px dashed #F2F2F2",

  // ticket-stub notches straddling the card edges (clipped by the card's overflow)
  "&::before, &::after": {
    content: '""',
    position: "absolute",
    left: -21.5,
    width: 40,
    height: 20,
    backgroundColor: theme.palette.background.page,
    borderRadius: 7,
  },

  "&::before": {
    top: -30,
  },

  "&::after": {
    bottom: -30,
  },

  [theme.down("xl")]: {
    width: 280,
  },

  [theme.down("md")]: {
    width: 210,
  },

  [theme.down("sm")]: {
    width: "100%",
    borderLeft: "none",
    borderTop: "3px dashed #F2F2F2",
    marginTop: 15,

    "&::before, &::after": {
      display: "none",
    },
  },
}));

export const PricesBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  gap: 10,
  alignItems: "center",
}));

export const SubmitButton = styled("button")(({ theme }) => ({
  ...theme.paddings(5, 10),
  width: 200,
  height: 48,
  color: theme.palette.text.white,
  backgroundColor: theme.palette.button.primary,
  border: `1px solid ${theme.palette.button.primary}`,
  borderRadius: 8,
  fontSize: 16,
  fontWeight: 700,
  cursor: "pointer",
  transition: "all 0.3s ease-out",

  "&:hover": {
    backgroundColor: theme.palette.button.primaryHover,
    border: `1px solid ${theme.palette.button.primaryHover}`,
  },

  [theme.down("md")]: {
    width: "100%",
  },
}));

export const Timelimit = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  gap: 3,
  fontSize: 18,

  "& > span": {
    color: theme.palette.text.secondary,
    fontSize: 12,
    lineHeight: "14px",
  },
}));

export const TariffItem = styled("div")(({ theme }) => ({
  ...theme.paddings(10, 0),
  ...theme.mixins.flexColumn,
  alignItems: "center",
  justifyContent: "center",
  gap: 10,
  width: "100%",
}));

export const TariffsButton = styled("button")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  fontSize: 15,
  fontWeight: 600,
  border: "none",
  backgroundColor: "transparent",
  cursor: "pointer",
  color: theme.palette.text.primary,
  gap: 5,

  "& > span": {
    display: "flex",
    fontSize: 16,
    transition: "transform .3s ease",
  },

  "& > span.active": {
    transform: "rotate(180deg)",
  },
}));
